// document.addEventListener("DOMContentLoaded", (e) => {
//   const headerWrapper = document.querySelector(".main-nav__wrapper");
//   window.addEventListener("scroll", (e) => {
//     if (window.scrollY > 100) {
//       headerWrapper.classList.add("fixed--header");
//     } else {
//       headerWrapper.classList.remove("fixed--header");
//     }

//     console.log(window.scrollY)
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const gallery = document.querySelector(".product_gallery_nav.vertical-slider-enabled");

  // Fallback in case the slider is blocked initially
  setTimeout(() => {
    if (gallery) {
      gallery.scrollTop = 1; // force reflow

      // If Flickity or your custom slider is used
      if (typeof Flickity !== 'undefined') {
        const flktyInstance = Flickity.data(gallery);
        if (flktyInstance) {
          flktyInstance.resize();
        }
      }

      // Trigger a synthetic scroll if needed
      gallery.dispatchEvent(new Event('scroll'));
    }

    // Trigger global resize event
    window.dispatchEvent(new Event('resize'));
  }, 1000); // wait 1s after DOM
});
